// extracted by mini-css-extract-plugin
module.exports = {"download-app-footer":"PaymentSuccessMobFooter_download-app-footer__qFCZp","cta":"PaymentSuccessMobFooter_cta__wK1Ln"};